module.exports = __webpack_public_path__ + "static/img/bystage_01.c6421a72.svg";